/**
 * 헤더·하단 메뉴 라벨의 영어 표기(#315). 한국어 라벨이 키다.
 * 메뉴에 라벨을 더하면 여기에도 더한다 — menu.test.ts 가 영어가 빠진 라벨을 보고한다.
 * (관리자 메뉴는 한국어 전용이라 넣지 않는다.)
 */
export const MENU_LABELS_EN: Record<string, string> = {
  '맞춤법 검사': 'Spell Check',
  '바른 맞춤법 검사': 'Bareun Spell Checker',
  '형태소 분석': 'Morphological Analysis',
  '단어 분절(토크나이저)': 'Tokenizer',
  '우리말샘 음소 검색': 'Urimalsaem Jamo Search',
  '사용자 사전': 'Custom Dictionary',
  '바른 소개': 'About Bareun',
  '다운로드': 'Download',
  '이전 버전': 'Previous Versions',
  '업데이트': 'Updates',
  '문서': 'Docs',
  'FAQ': 'FAQ',
  '우리말 지식': 'Korean Knowledge',
  '기술지원': 'Support',
  '요금 안내': 'Pricing',
  '2026 생활기록부 맞춤법 검사': '2026 School Record Spell Check'
};
